import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTaco4Foods } from '../../../redux/actions/nutridataActions';
import { useNavigate } from 'react-router-dom';

import SearchBar from '../../../components/SearchBar/SearchBar';
import Pagination from '../../../components/Pagination/Pagination';
import SearchBarFoods from '../../../components/SearchBarFoods/SearchBarFoods';

import '../styles/Nutridata.css';
import { setCurrentTaco4Food } from '../../../redux/slices/nutridataSlice';
import LoadingEllipsis from '../../../components/LoadingEllipsis/LoadingEllipsis';

const GetTaco4Foods = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [searchText, setSearchText] = useState("");

  const { taco4Foods = [], loading, error } = useSelector((state) => state.nutridata);


  useEffect(() => {
    dispatch(fetchTaco4Foods()).then((response) => {
      // console.log("Resposta da API:", response);
    });
  }, [dispatch]);

  const handleSearch = (searchText) => {
    setSearchText(searchText);
  };

  const handleShowFoodDetails = (food_id) => {
    console.log("Selected food_id:", food_id);
    dispatch(setCurrentTaco4Food(food_id))
    navigate(`/home/nutridata/show/taco4foods/${food_id}`);
  };

  const filteredFoods = Array.isArray(taco4Foods)
    ? taco4Foods.filter((food) =>
      `${food.food_name} ${food.category_name}`
        .toLowerCase()
        .includes(searchText.trim().toLowerCase())
    )
    : [];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredFoods.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (loading) return <LoadingEllipsis message='Carregando Aliemento Tabela Taco4' />;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <div className="col-md-12">
        <h3>Lista de Alimentos <span className="title-span">(referênciada na tabela *TACO 4  <strong>Total de registros: {taco4Foods.length}</strong> )</span></h3>
        {/* <SearchBarFoods onSearch={handleSearch} /> */}
        <SearchBar onSearch={handleSearch} />
      </div>

      <div className="main-food">
        <div className="food-content">
          {loading ? (
            <LoadingEllipsis message='Carregando...' />
          ) : currentItems.length === 0 ? (
            <div className="rowMessage">Nenhum alimento encontrado</div>
          ) :
            <ul>
              {currentItems.map((food, key) => (
                <li key={food.food_id} >
                  <a onClick={(event) => { event.preventDefault(); handleShowFoodDetails(food.taco4_id) }} href="#" className='custom-cursor-li'>
                    <div className="row-food">
                      <div className="col1">
                        <label htmlFor="alimento">Alimento</label>
                        <div>{food.food_name}</div>
                      </div>
                      <div className="col2">
                        <label htmlFor="categoria">Categoria</label>
                        <div>{food.category_name}</div>
                      </div>
                      <div className="col3">
                        <label htmlFor="calorias">Calorias</label>
                        <div>{food.kcal ?? "0.00"} {food.kcal_unit}</div>
                      </div>
                      <div className="col4">
                        <label htmlFor="carboidratos">Carboidratos</label>
                        <div>{food.carbohydrates ?? "0.00"} {food.carbohydrates_unit}</div>
                      </div>
                      <div className="col5">
                        <label htmlFor="proteinas">Proteínas</label>
                        <div>{food.protein ?? "0.00"} {food.protein_unit}</div>
                      </div>
                      <div className="col6">
                        <label htmlFor="gorduras_aturadas">G. Saturadas</label>
                        <div>{food.saturated ?? "0.00"} {food.saturated_unit}</div>
                      </div>
                    </div>
                  </a>
                </li>
              ))}
            </ul>
          }
        </div>
      </div>
      <Pagination
        totalItems={filteredFoods.length}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        paginate={paginate}
      />

    </>
  );
};

export default GetTaco4Foods;
